<template>
  <div>
    <div class="text-sm font-weight-medium secondary--text mb-1">
      申告
    </div>

    <div
      v-for="row in rows"
      :key="`check-in-declaration-${row.itemId}`"
      class="d-flex align-center flex-wrap check-in-declarations__row"
    >
      <v-switch
        :input-value="row.declared"
        :label="row.name"
        :disabled="disabled || row.declaredToday"
        hide-details
        inset
        class="mr-6 mt-0 pt-0"
        @change="toggle(row, $event)"
      />

      <!-- 1営業日に1回までの項目で、同じ日のほかのタイムカードですでに申告済み -->
      <span
        v-if="row.declaredToday"
        class="check-in-declarations__declared-today text-xs"
      >
        本日申告済み
      </span>

      <v-text-field
        v-if="withAmount && row.declared && row.hasAmount"
        :value="row.amount"
        :disabled="disabled"
        type="number"
        min="0"
        step="100"
        suffix="円"
        dense
        hide-details
        class="check-in-declarations__amount mt-0 pt-0"
        @change="changeAmount(row, $event)"
      />
    </div>

    <p
      v-if="rows.length === 0"
      class="text-xs secondary--text mb-0"
    >
      申告項目がありません
    </p>
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

// 出勤時の申告のトグル。value は [{ itemId, amount }]。
// 今の設定から外れた項目でも、すでに付いている申告は表示して外せるようにする
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },

    // その店舗に当てはまる申告項目(CheckInSettings の items)
    items: {
      type: Array,
      default: () => [],
    },

    // すでに付いている申告(タイムカードの declarations)。項目名の表示に使う
    declared: {
      type: Array,
      default: () => [],
    },
    withAmount: {
      type: Boolean,
      default: false,
    },

    // 同じ営業日のほかのタイムカードですでに申告済みの、「1営業日に1回まで」の項目の ID
    declaredTodayItemIds: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const rows = computed(() => {
      const selected = {}
      props.value.forEach(declaration => { selected[+declaration.itemId] = declaration })

      const fromSettings = props.items.map(item => ({
        itemId: +item.id,
        name: item.name,
        defaultAmount: item.defaultAmount,
      }))
      const known = fromSettings.map(row => row.itemId)
      const fromDeclared = props.declared
        .filter(declaration => !known.includes(+declaration.itemId))
        .map(declaration => ({ itemId: +declaration.itemId, name: declaration.name, defaultAmount: declaration.amount }))

      return [...fromSettings, ...fromDeclared].map(row => {
        const current = selected[row.itemId]
        const amount = current && current.amount !== undefined ? current.amount : row.defaultAmount

        return {
          ...row,
          declared: !!current,
          declaredToday: !current && props.declaredTodayItemIds.map(Number).includes(row.itemId),
          amount,
          hasAmount: amount !== null && amount !== undefined,
        }
      })
    })

    const toggle = (row, isOn) => {
      const rest = props.value.filter(declaration => +declaration.itemId !== row.itemId)

      emit('input', isOn ? [...rest, { itemId: row.itemId, amount: row.defaultAmount }] : rest)
    }

    const changeAmount = (row, amount) => {
      emit('input', props.value.map(declaration => {
        if (+declaration.itemId !== row.itemId) return declaration

        return { ...declaration, amount: amount === '' ? null : Number(amount) }
      }))
    }

    return {
      rows,
      toggle,
      changeAmount,
    }
  },
}
</script>

<style scoped>
.check-in-declarations__amount {
  max-width: 120px;
}
/* Vuetify の color pack は無効のため、色は独自クラスで指定する */
.check-in-declarations__declared-today {
  display: inline-block;
  border-radius: 999px;
  padding: 1px 8px;
  background: rgba(86, 202, 0, 0.12);
  color: #3c8c00;
  font-weight: 600;
}
/* トグル・項目名・金額の欄を同じ高さに揃えるため、余白は入力部品ではなく行に持たせる。
   行の高さを固定して、金額の欄が出ても行の間隔が変わらないようにする */
.check-in-declarations__row {
  min-height: 48px;
}
</style>
